import React from "react";
import classnames from "classnames";
import { ICellRendererParams } from "@ag-grid-community/core";

import { GridTransaction, TransactionType } from "../../../../types";
import { SubdirectoryArrow } from "../../../Icons";

import styles from "./ParticipantRenderer.module.scss";

interface Props extends ICellRendererParams {
  data: GridTransaction;
}

const ParticipantRenderer = ({
  data: {
    sourceParticipantRegNumber,
    sourceParticipantDisplayName,
    targetParticipantRegNumber,
    targetParticipantDisplayName,
    transactionType,
  },
}: Props) => {
  const getParticipantData = (regNumber: number, displayName?: string) => (
    <div className={styles.line}>
      <div className={styles.displayName}>{displayName}</div>
      <div className={styles.number}>{regNumber}</div>
    </div>
  );

  return (
    <div className={styles.participantBlock}>
      {sourceParticipantRegNumber &&
        getParticipantData(
          sourceParticipantRegNumber,
          sourceParticipantDisplayName
        )}
      {transactionType !== TransactionType.Retreading && (
        <>
          {sourceParticipantRegNumber ? (
            <div className={styles.linkedBlock}>
              <SubdirectoryArrow
                className={styles.linkedIcon}
                width={12}
                height={16}
              />
              <div className={classnames(styles.number, styles.displayName)}>
                {targetParticipantDisplayName}
              </div>
              <div className={styles.number}>
                {transactionType === TransactionType.Disposition ? "· " : ""}
                {targetParticipantRegNumber}
              </div>
            </div>
          ) : (
            getParticipantData(
              targetParticipantRegNumber,
              targetParticipantDisplayName
            )
          )}
        </>
      )}
    </div>
  );
};

export default ParticipantRenderer;
